import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import ContainerRoute from "@components/common/routing/container-route";
import { useProviders } from "@queries/integration";
import { useProviderIcons } from "@queries/provider-icon";

import { default as IntegrationsList } from "./list";
import SyncHistory from "./sync-history/sync-history";

export default function Integrations({ responsiveStyles = {} }) {
  const { path } = useRouteMatch();

  const { data: providers } = useProviders({ includeDisabled: true });

  const providerIds = providers?.map((provider) => provider.id) || [];
  useProviderIcons(providerIds, {
    enabled: providerIds.length > 0,
  });

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={`${path}/:organizationCode/:connectionId/sync-history`}
        component={SyncHistory}
        responsiveStyles={responsiveStyles}
      />
      <ContainerRoute
        exact={true}
        path={path}
        component={IntegrationsList}
        responsiveStyles={responsiveStyles}
      />
      <Route path={`${path}/*`}>
        <Redirect to={path} />
      </Route>
    </Switch>
  );
}
